/**
 * 対応終了した EVM chain の既存データ表示・検索用メタデータ。
 * RPC client を持たず、新規登録・同期・解析の対象には含めない。
 */
export const retiredEvmChains = [
  { id: 19011, network: 'home-verse', name: 'HOME Verse' },
  { id: 29548, network: 'mch-verse', name: 'MCH Verse' },
  { id: 1923, network: 'swellchain', name: 'Swellchain' },
  { id: 1284, network: 'moonbeam', name: 'Moonbeam' },
  { id: 1285, network: 'moonriver', name: 'Moonriver' },
  { id: 3776, network: 'astar-zkevm', name: 'Astar zkEVM' },
  { id: 250, network: 'fantom', name: 'Fantom' },
  { id: 428, network: 'geso-verse', name: 'Geso Verse' },
  { id: 1101, network: 'polygon-zkevm', name: 'Polygon zkEVM' },
  { id: 2000, network: 'doge-chain', name: 'Dogechain' },
  { id: 2400, network: 'tcg-verse', name: 'TCG Verse' },
  { id: 5555, network: 'chain-verse', name: 'Chain Verse' },
  { id: 16116, network: 'defi-verse', name: 'DeFiVerse' },
  { id: 42766, network: 'zkfair', name: 'ZKFair' },
  { id: 50005, network: 'yooldo-verse', name: 'Yooldo Verse' },
  { id: 50104, network: 'sophon', name: 'Sophon' },
  { id: 7225878, network: 'saakuru', name: 'Saakuru' },
  { id: 7777777, network: 'zora', name: 'Zora' },
] as const
